module.exports = __webpack_public_path__ + "media/project/survey-success-044a8a4c.svg";